/*eslint-disable*/
import { noop } from "../../../utils/general";
import { isRequiredRule } from "../../../helpers/validators";

//restricted tenant
import { isRestrictedTenant } from "../../../helpers/users";

// user permissions
import { getApplicationsRoles } from "../../../helpers/user";

import i18next from 'i18next'

const nameRegex = /^[a-zA-Z ]+$/

// regex that prevents its.jnj.com email but accepts all others  
const EMAIL_REGEX = /^(?!.*its\.jnj\.com$)[^\s@]+@[^\s@]+\.[a-zA-Z]{1,}$/
// regex that accepts any email
const EMAIL_REGEX_ANY_EMAIL = /^[^\s@]+@[^\s@]+\.[a-zA-Z]{1,}$/
// regex that accepts only a jnj email
const EMAIL_REGEX_ONLY_JNJ = /^[^\s@]+@its\.jnj\.com$/


///^[^\s@]+@[a-zA-Z]+(?:\.[a-zA-Z]{2,4})?$/

const phoneRegex = /^\+[1-9]\d{10}$/;

export const hasJnjGroupAccess = () => {
  const groups = getApplicationsRoles().groups.find((group) => group === 'xIAM API Gateway - JnJ User Manager');
  return Boolean(groups);
};

const isValidNameRule = (value) => {
  if (value && value.length > 50) {
    return { isValid: false, errorMsg: "More than 50 characters not allowed" };
  }

  // if (value && !nameRegex.test(value)) {
  //   return { isValid: false, errorMsg: "Please enter name using only letters, without digits or special characters." };
  // }
  return { isValid: true, errorMsg: "" };
};

const newAndOldEmailsMatch = (oldEmail, newEmail) => (oldEmail === newEmail);

const jnjPermissionsAndValidEmail = (canCreateJNJUser, email, emailRegex) => (canCreateJNJUser && email && emailRegex.test(email));

const isJNJEmail = (email, jnjEmailRegex) => (email && jnjEmailRegex.test(email));

const isEmail = (email, emailRegex) => (email && emailRegex.test(email));


const isValidEmailRule = (value, canCreateJNJUser, existingUser, emailRegex=EMAIL_REGEX) => {
  const valueLowercase = value.toLowerCase()
  if (newAndOldEmailsMatch(existingUser?.emails?.[0].value.toLowerCase(), valueLowercase)) {
    return { isValid: true }
  }
  if (jnjPermissionsAndValidEmail(canCreateJNJUser, valueLowercase, EMAIL_REGEX_ANY_EMAIL)) {
    return { isValid: true };
  }
  if (existingUser?.emails?.[0].value.toLowerCase().endsWith('its.jnj.com') && isJNJEmail(valueLowercase, EMAIL_REGEX_ONLY_JNJ)) {
    return { isValid: false, errorMsg: "You do not have permission to change this J&J email to a different J&J email." }
  }
  if (existingUser?.emails && isJNJEmail(valueLowercase, EMAIL_REGEX_ONLY_JNJ)) {
    return { isValid: false, errorMsg: "You do not have permission to change this email to a J&J email." }
  }
  if (isJNJEmail(valueLowercase, EMAIL_REGEX_ONLY_JNJ)) {
    return { isValid: false, errorMsg: "You do not have permission to create a user with a J&J email." }
  }
  if (!isEmail(valueLowercase, emailRegex)) {
    return { isValid: false, errorMsg: i18next.t('label-mandatory-email-field-invalid') };
  }
  return { isValid: true };
};

const isValidPhoneNumberRule = (value) => {
  if(value && !value?.startsWith('+')) {
    return { isValid: false, errorMsg: i18next.t('label-mandatory-phone-field-validation') };
  }
  if (value && value.length > 100) {
    return { isValid: false, errorMsg: i18next.t('label-mandatory-phone-field-limitation-digit') };
  }
  return { isValid: true, errorMsg: '' };
};

const firstNameFormatValidator = (user, errorMsgs) => {
  const { errorMsg="" } = isValidNameRule(user.firstName);
  errorMsgs.firstName = errorMsg;
};

const lastNameFormatValidator = (user, errorMsgs) => {
  const { isValid, errorMsg="" } = isValidNameRule(user.lastName);
  errorMsgs.lastName = errorMsg;
};

const emailFormatValidator = (user, errorMsgs, emailRegex, canCreateJNJUser, existingUser) => {
  const { isValid, errorMsg } = isValidEmailRule(user.email, canCreateJNJUser, existingUser, emailRegex);
  if (isValid) errorMsgs.email = "";
  else errorMsgs.email = errorMsg;
};

const phoneNumberFormatValidator = (user, errorMsgs) => {
  const { isValid, errorMsg } = isValidPhoneNumberRule(user.phoneNumber);
  if (isValid) errorMsgs.phoneNumber = "";
  else errorMsgs.phoneNumber = errorMsg;
};

const firstNameRequiredValidator = (user, errorMsgs) => {
  const { isValid } = isRequiredRule(user.firstName);
  if (!isValid) errorMsgs.firstName = i18next.t('label-mandatory-first-name-field');
};

const lastNameRequiredValidator = (user, errorMsgs) => {
  const { isValid } = isRequiredRule(user.lastName);
  if (!isValid) errorMsgs.lastName = "Last name is required.";
};

const emailRequiredValidator = (user, errorMsgs) => {
  const { isValid } = isRequiredRule(user.email);
  if (!isValid) errorMsgs.email = i18next.t('label-mandatory-email-field');
};

const firstNameValidator = (user, errorMsgs) => {
  firstNameFormatValidator(user, errorMsgs);
  firstNameRequiredValidator(user, errorMsgs);
};

const lastNameValidator = (user, errorMsgs) => {
  lastNameFormatValidator(user, errorMsgs);
  isRestrictedTenant() && lastNameRequiredValidator(user, errorMsgs);
};

const emailValidator = (user, errorMsgs, emailRegex, canCreateJNJUser, existingUser) => {
  emailFormatValidator(user, errorMsgs, emailRegex, canCreateJNJUser, existingUser);
  emailRequiredValidator(user, errorMsgs);
};

const phoneNumberValidator = (user, errorMsgs) => {
  phoneNumberFormatValidator(user, errorMsgs);
};

export const validateUserSubmit = (user, emailRegex, canCreateJNJUser, existingUser) => {
  const errorMsgs = {};
  firstNameValidator(user, errorMsgs);
  lastNameValidator(user, errorMsgs);
  emailValidator(user, errorMsgs, emailRegex, canCreateJNJUser, existingUser);
  phoneNumberValidator(user, errorMsgs);
  return errorMsgs;
};

const FIELD_ID_FORMAT_VALIDATOR = {
  firstName: firstNameValidator,
  lastName: lastNameValidator,
  email: emailValidator,
  phoneNumber: phoneNumberValidator,
};

export const validateUserChange = (user, errors, fieldId, emailRegex, canCreateJNJUser, existingUser = {}) => {
  const errorMsgs = {};
  const handler = FIELD_ID_FORMAT_VALIDATOR[fieldId] || noop;
  handler(user, errorMsgs, emailRegex, canCreateJNJUser, existingUser);

  return { ...errors, ...errorMsgs };
};
